import { render, staticRenderFns } from "./PlaceList.vue?vue&type=template&id=76fb09b6"
import script from "./PlaceList.vue?vue&type=script&lang=js"
export * from "./PlaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports